import { useCallback, useMemo, useState } from 'react'
import { Button, Row, Col } from 'antd'
import moment from 'moment'
import Szth from '@/pages/Bmjy/components/Sztj'
import Bmlrtj from '@/pages/Bmjy/components/Bmlrtj'
import Bmlrph from '@/pages/Bmjy/components/Bmlrph'
import Wtdsjtj from '@/pages/Bmjy/components/Wtdsjtj'
import Gzlsjtj from '@/pages/Bmjy/components/Gzlsjtj'
import Kpsjtj from '@/pages/Bmjy/components/Kpsjtj'
import Dksjtj from '@/pages/Bmjy/components/Dksjtj'
import Cbzcsjtj from '@/pages/Bmjy/components/Cbzcsjtj'
import Jxzsjtj from '@/pages/Bmjy/components/Jxzsjtj'
import YshYf from '@/pages/Bmjy/components/YshYf'

const Index = () => {
  const [updateTime, setUpdateTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'))

  const handleFlush = useCallback(() => {
    setUpdateTime(moment().format('YYYY-MM-DD HH:mm:ss'))
  }, [])

  const visibleMessage = useMemo(() => {
    return `以下数据截至今天${moment(updateTime).format('HH:mm')}，`
  }, [updateTime])

  return (
    <div>
      <div className='text-center'>{visibleMessage}如需实时数据请手动 <Button type="link" onClick={handleFlush}>刷新</Button></div>
      <Row gutter={[16, 16]} className='mb-20'>
        <Col span={7}>
          <div style={{height: '528px'}}>
            <Szth updateTime={updateTime} />
          </div>
        </Col>
        <Col span={11}>
          <div style={{height: '528px'}}>
            <Bmlrtj updateTime={updateTime} />
          </div>
        </Col>
        <Col span={6}>
          <div style={{height: '528px'}}>
            <Bmlrph updateTime={updateTime} />
          </div>
        </Col>
        <Col span={24}>
          <Wtdsjtj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Gzlsjtj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Kpsjtj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Dksjtj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Cbzcsjtj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Jxzsjtj updateTime={updateTime} />
        </Col>
        {/* <Col span={24}>
          <YshYf updateTime={updateTime} />
        </Col> */}
      </Row>
    </div>
  )
}

export default Index
